export enum QueuedReportListColumns {
  title = "Report Title",
  type = "Type",
  reason = "Reason",
  owner = "Owner",
  created_at = "Report Date",
  action = "Action"
}

export enum ReportHistoryListColumns {
  title = "Report Title",
  type = "Type",
  reason = "Reason",
  owner = "Owner",
  created_at = "Report Date",
  action = "Action Type",
  actioned_by = "Actioned By",
  actioned_at = "Actioned At",
}

export const QueuedReportAllColumnKeys = Object.values(QueuedReportListColumns);
export const ReportHistoryAllColumnKeys = Object.values(ReportHistoryListColumns);
